import React from "react";
import AgentDeskPage from "./Projects/AgentDesk";
import SmartHirePage from "./Projects/SmartHire";
import CherokeeInvoiceParserPage from "./Projects/CherokeeInvoiceParserPage";
import LeadFlow from "./Projects/LeadFlow";
import KnowledgeFlowPage from "./Projects/KnowledgeFlowPage";
import DailyJiraSummarizerPage from "./Projects/DailyJiraSummarizerPage";
import JiraTicketGeneratorPage from "./Projects/JiraTicketGeneratorPage";
import BusinessReportAutomationPage from "./Projects/BusinessReportAutomationPage";
import DocumentTranslationAutomationPage from "./Projects/DocumentTranslationAutomationPage";
import CustomerFeedbackAnalysisPage from "./Projects/CustomerFeedbackAnalysisPage";
import AIProductEnrichmentAutomationPage  from "./Projects/AIProductEnrichmentAutomationPage";
import AIProposalAutomationSystemPage  from "./Projects/AIProposalAutomationSystemPage";


import { n8nProjectDetails } from "../Details";
import { useParams } from 'react-router-dom';

function DetailsN8N() {
  const { id } = useParams();

  const project = n8nProjectDetails.find((item) => item.id === id);

  if (!project) {
    return <main className="container mx-auto max-width pt-10 pb-20 ">
      <section>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Project not found
        </h1>
      </section>
    </main>
  }

  if(id == "agentdesk") {
    return (
      <AgentDeskPage />
    );
  }

  if(id == "smarthire") {
    return (
      <SmartHirePage />
    );
  }

  if(id == "ai-pdf-invoice-parser") {
    return (
      <CherokeeInvoiceParserPage />
    );
  }

  if(id == "lead-flow") {
    return (
      <LeadFlow />
    );
  }

  if(id == "knowledge-flow") {
    return (
      <KnowledgeFlowPage />
    );
  }

  if(id == "automating-daily-ticket-summaries") {
    return (<DailyJiraSummarizerPage />)
  }

  if(id == "jira-ticket-generator") {
    return (<JiraTicketGeneratorPage />)
  }


if(id == "business-report-automation") {
    return (<BusinessReportAutomationPage />)
  }

  if(id == "document-translation-automation") {
    return (<DocumentTranslationAutomationPage />)
  }

  if(id == "customer-feedback-ai-analysis-system") {
    return (<CustomerFeedbackAnalysisPage />)
  }

  if(id == "ai-product-data-enrichment-automation") {
    return (<AIProductEnrichmentAutomationPage />)
  }

    if(id == "ai-proposal-automation-system") {
    return (<AIProposalAutomationSystemPage />)
  }
 
}

export default DetailsN8N;
